import { render, staticRenderFns } from "./PlatformUserDetails.vue?vue&type=template&id=66d0096a&scoped=true&"
import script from "./PlatformUserDetails.vue?vue&type=script&lang=js&"
export * from "./PlatformUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./PlatformUserDetails.vue?vue&type=style&index=0&id=66d0096a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0096a",
  null
  
)

export default component.exports